{
  "client": {
    "details": "Détails",
    "clientList": "Liste des clients",
    "allClients": "Tous les clients",
    "fuseStart": "Date de début FuSE",
    "addClient": "Ajouter un client",
    "contacts": "Coordonnées",
    "documents": "Documents",
    "companyLegalName": "Dénomination sociale de la société",
    "websiteURL": "URL du site Web",
    "clientStatus": "Statut du client",
    "fuseStartDate": "Date de début FuSE",
    "fuseEndDate": "Date de fin FuSE",
    "feinBusinessNumber": "Numéro d'identification d'employeur fédéral (FEIN) ou numéro d'entreprise",
    "corporateAddress": "Adresse de l'entreprise",
    "programCountry": "Pays du programme",
    "country": "Pays",
    "countryPlaceholder": "Choisissez le pays de votre programme",
    "unitedStates": "États-Unis",
    "canada": "Canada",
    "remittanceInformation": "Informations sur le versement",
    "remittanceAddress": "Adresse de versement",
    "bankingInformation": "Informations bancaires",
    "bankName": "Nom de la banque",
    "bankAccountNumber": "Numéro de compte bancaire",
    "bankRoutingNumber": "Numéro de routage de la banque",
    "bankAccountType": "Type de compte bancaire",
    "stripeDetails": "Détails Stripe",
    "noStripeAccountConnected": "Aucun compte Stripe connecté",
    "addStripeDetails": "Ajouter les détails Stripe",
    "stripeUnavailableForCanada": "Les paiements Stripe ne sont pas disponibles pour les clients situés au Canada.",
    "accountDetails": "Détails du compte",
    "displayName": "Nom d'affichage",
    "noDisplayName": "Aucun nom d'affichage",
    "contactEmail": "Courriel de contact",
    "enterEmailAddress": "Entrer l'adresse courriel",
    "linkedBankAccount": "Compte bancaire lié",
    "updateBankAccount": "Mettre à jour le compte bancaire",
    "completeBankingDetails": "Compléter les détails bancaires",
    "routingNumber": "Numéro de routage",
    "last4": "4 derniers",
    "retired": "Retiré",
    "retireClient": "Retirer le client",
    "retire": "Retirer",
    "lastReportingPeriod": "Dernière période de déclaration",
    "retireButton": "RETIRER",
    "retiringButton": "RETRAIT EN COURS...",
    "retireWarning": "Avertissement : Le retrait de ce client retirera également tous ses équipements, et toutes les données d'utilisation de l'équipement",
    "retireWarningEnd": "seront supprimées.",
    "theLastReportingPeriod": "la dernière période de déclaration",
    "retireConfirmation1": "Je comprends que le retrait de ce client retirera également tous ses équipements.",
    "retireConfirmation2Start": "Je comprends que toutes les données d'utilisation de l'équipement",
    "retireConfirmation2End": "seront supprimées.",
    "selectPeriod": "Sélectionner une période…",
    "noProgramMessage": "Un programme doit être ajouté à ce client avant de sélectionner la dernière période de reporting."
  },
  "contacts": {
    "pointsOfContact": "Points de contact",
    "pointsOfContactDescription": "Tous les utilisateurs Admin de cette {{entityType}} seront considérés comme des points de contact.",
    "pointsOfContactDescriptionClient": "Tous les utilisateurs Admin de ce Client et {{entityType}} seront considérés comme des points de contact.",
    "client": "Client",
    "corporateContacts": "Coordonnées professionnelles",
    "remittanceContacts": "Coordonnées de versement",
    "facilityContacts": "Coordonnées d'installation",
    "contact": "Contact",
    "contactRole": "Rôle du contact",
    "contactName": "Nom du contact",
    "contactEmail": "Courriel du contact",
    "contactPhone": "Téléphone du contact",
    "choose": "Choisir..."
  },
  "documents": {
    "title": "Bibliothèque de documents",
    "uploadDocument": "Télécharger le document",
    "documentName": "Nom du document",
    "documentType": "Type de document",
    "dateUploaded": "Date de téléchargée",
    "uploadedBy": "Téléchargé par",
    "noDocumentsFound": "Aucun document trouvé",
    "noDocumentsMatchFilters": "Aucun document ne correspond aux filtres sélectionnés",
    "clearFilters": "Effacer les filtres",
    "characterLimit": "/500 caractères",
    "noComments": "Aucun commentaire",
    "saveChanges": "Enregistrer les modifications",
    "cancelEditing": "Annuler l'édition",
    "downloadDocument": "Télécharger le document",
    "seeMore": "Voir plus",
    "collapse": "Réduire",
    "editComments": "Modifier les commentaires",
    "deleteDocument": "Supprimer le document",
    "deleteDocumentWarning": "Voulez-vous vraiment supprimer ce document?",
    "deleteDocumentConfirm": "Je comprends que cette action est irréversible.",
    "processing": "En cours de traitement",
    "needsReview": "En attente de revue",
    "selectDocumentType": "Sélectionner le type de document",
    "addComments": "Ajouter des commentaires (facultatif)",
    "cancel": "Annuler",
    "upload": "Télécharger",
    "dropFiles": "Déposez les fichiers ici ou cliquez pour",
    "browse": "parcourir",
    "selectedFile": "Fichier sélectionné",
    "cannotDownloadWhileProcessing": "Impossible de télécharger le document en cours de traitement",
    "cannotDownloadFileNeedsReview": "Impossible de télécharger le document en attente de revue",
    "searchByName": "Recherche par nom",
    "downloadSelected": "Télécharger la sélection",
    "preparingDownload": "Préparation...",
    "all": "Tous",
    "filterDocuments": "Filtrer les documents",
    "bulkDownloadPartial": "{{downloaded}} document(s) téléchargé(s), {{skipped}} ignoré(s) (en traitement ou en attente de revue).",
    "bulkDownloadUnavailable": "{{count}} document(s) sélectionné(s) ne peuvent pas être téléchargés pour le moment (en traitement ou en attente de revue)."
  },
  "statements": {
    "statements": "Relevés",
    "statementList": "Liste des relevés",
    "incentiveStatements": "Relevés d'incitatifs",
    "summary": "Résumé (imprimable)",
    "details": "Détails (imprimable)",
    "viewIndividualPrograms": "Voir les programmes individuels",
    "hideIndividualPrograms": "Masquer les programmes individuels",
    "viewIndividualProgram": "Voir le programme individuel",
    "hideIndividualProgram": "Masquer le programme individuel",
    "noStatementsFound": "Aucun relevé trouvé",
    "allPrograms": "Tous les programmes",
    "individualStatement": "Relevé individuel",
    "downloadPDF": "Télécharger PDF",
    "downloadCSV": "Télécharger CSV",
    "detailedStatement": "Relevé détaillé",
    "incentiveStatement": "Relevé d'incitatifs",
    "credits": "Crédits",
    "accountEndingIn": "Compte terminant par",
    "creditPrice": "Prix du crédit",
    "totalValue": "Valeur totale",
    "recCost": "Coût des RECs",
    "brokerCost": "Coût de courtage",
    "taxesOnCreditSale": "Taxes sur la vente de crédits",
    "taxesOnServices": "Taxes sur les services",
    "fuseServiceFee": "Frais de service FuSE",
    "netIncentive": "Incitatif net",
    "totals": "Totaux",
    "costRecoup": "Recouvrement des coûts (si applicable)",
    "grandTotal": "Total général",
    "calculationKey": "Clé de calcul",
    "definition": "Définition",
    "taxesOnCreditSaleDefinition": "Applicable uniquement au programme BC LCFS. Taxes calculées à 5 % de la valeur totale.",
    "taxesOnServicesDefinition": "TPS, TVH et TVP applicables, calculées selon la province du siège social du client.",
    "caFuseServiceFeeDefinition": "Commission convenue retenue par FuSE.",
    "creditsDefinition": "La génération de crédits est basée sur la quantité de kWh déclarés, utilisés ou distribués par votre équipement électrique.",
    "creditPriceDefinition": "Le prix du crédit est déterminé par la valeur de chaque crédit vendu à des entités réglementées (sociétés pétrolières et gazières) sur le marché libre.",
    "recCostDefinition": "Les certificats d'énergie renouvelable (RECs) sont des mégawattheures d'électricité propre achetés en votre nom afin d'augmenter le nombre de crédits générés, lorsque cela est financièrement avantageux. L'achat de RECs à ce coût entraîne une augmentation des crédits et des revenus générés.",
    "brokerCostDefinition": "Coût administratif associé aux services de courtage, à l'achat de RECs et à la conclusion de contrats avec des entités réglementées.",
    "fuseServiceFeeDefinition": "Commission convenue retenue par FuSE après la soustraction du coût des RECs et du coût de courtage.",
    "costRecoupDefinition": "Fonds retenus lorsque FuSE a avancé le coût du matériel de mesure ou d'autres activités d'Exchange.",
    "netIncentiveDefinition": "Montant remis à votre organisation après que tous les coûts et les frais ont été soustraits.",
    "incentiveStatementNotice": "Le relevé d'incitatifs ci-dessous reflète les crédits générés par la flotte/l'équipement électrique inscrit de votre organisation dans le cadre d'un programme de norme sur les carburants propres applicable à l'État, à la province ou au niveau fédéral. Pour toute question ou information supplémentaire, veuillez contacter notre équipe à support@usefuse.com ou via la fonction de chat dans l'application."
  },
  "commissions": {
    "commissions": "Commissions",
    "fuseCommissions": "Commissions FuSE",
    "percentage": "Pourcentage",
    "fixedRate": "Taux fixe",
    "effectiveStartDate": "Date de début effective",
    "effectiveEndDate": "Date de fin effective",
    "salesCommissions": "Commissions de vente",
    "referralCommissions": "Commissions de référence",
    "referralPartner": "Partenaire de référence"
  },
  "user": {
    "user": "Utilisateur",
    "users": "Utilisateurs",
    "userList": "Liste des utilisateurs",
    "company": "Compagnie",
    "lastLogin": "Dernière connexion",
    "addUser": "Ajouter un utilisateur",
    "userRole": "Rôle utilisateur",
    "userStatus": "Statut utilisateur",
    "inactive": "Inactif",
    "email": "Courriel",
    "phone": "Téléphone",
    "noUsersFound": "Aucun utilisateur trouvé",
    "userInformation": "Informations utilisateur",
    "contactInformation": "Informations de contact",
    "created": "Créé",
    "updatePassword": "Mettre à jour le mot de passe",
    "currentPassword": "Mot de passe actuel",
    "newPassword": "Nouveau mot de passe",
    "confirmNewPassword": "Confirmer le nouveau mot de passe",
    "passwordRegex": "Le mot de passe doit contenir au moins 16 caractères et doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial (!@#$%^&*)"
  }
}
